const Link = "https://mastery.masterybrandambassador.com";

function GetLink() {
  return Link;
}

module.exports = GetLink;
